import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { ShareDataService } from '@services/share-data.service';
import { Subscription } from 'rxjs';
import { ExamineesService } from '../../services/examinees.service';
import { WebErrorService } from '@services/webError.service';


@Component({
  selector: 'app-add-examinee',
  templateUrl: './add-examinee.component.html',
  styleUrls: ['./add-examinee.component.scss']
})
export class AddExamineeComponent implements OnInit {

  examineeDetailsForm: FormGroup;
  duplicateDataFlag = false;
  errorMessage: string;
  examineeData$: Subscription | undefined;
  action = 'createUser';
  emailRegex: any;
  statusList: any;
  inValidEmail: boolean = false;
  inValidPhone: boolean = false;
  constructor(
    private examineesService: ExamineesService,
    private router: Router,
    private messageService: MessageService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    private shareDataService: ShareDataService,
    public dialogRef: MatDialogRef<AddExamineeComponent>
  ) { }

  sendMessage(): void {
    // send message to subscribers via observable subject
    this.messageService.sendMessage('Message from Home Component to App Component!');
  }

  ngOnInit(): void {
    this.examineesService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})
    this.emailRegex = RegExp(this.shareDataService.globalEmailRegexPattern);

    this.examineeDetailsForm = new FormGroup({
      firstName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
      ]),
      phone: new FormControl(null, [
        // Validators.required,
        Validators.minLength(5),
        Validators.maxLength(24),
        Validators.pattern(/^(?:\+?(\d{0,3}))?[- \(]*(\d{1,9})[-. \/)]*(\d{1,9})[-. \/]*(\d{1,9})*[-. \/]*(\d{1,9})(?: *x(\d))?$/)
      ]),
      emailId: new FormControl(null, [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(124),
        Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[-]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)+\.[A-Za-z]{2,4}$/)
        //Validators.pattern(this.emailRegex)
        //Validators.pattern(/^[a-zA-Z]+[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)*\.[A-Za-z]{1,3}$/)
        // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_-]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)\.[A-Za-z]{2,3}$/)
      ]),
      password: new FormControl(null, [
        Validators.required,
        Validators.maxLength(20),
        // Validators.minLength(12),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%])[a-zA-Z0-9!@#$%]{12,}$'),
        this.validatePassword.bind(this),
        // Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()-_=+/\|";:<>,.`~])[A-Za-z\d@$!%*?&#^()-_=+/\|";:<>,.`~]{6,20}$/)
      ]),
      status: new FormControl('true', [Validators.required]),

    });
  }

  get f(): any {
    return this.examineeDetailsForm.controls;
  }

  onClickOutside(event: any, name) {
    if(event && name == 'email') {
      this.inValidEmail = true; this.inValidPhone = false;
    } else {
      this.inValidEmail = false;
    }
    if(event && name == 'phone') {
      this.inValidEmail = false; this.inValidPhone = true;
    } else {
      this.inValidPhone = false;
    }
  }

  validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    let email = this.examineeDetailsForm?.get('emailId').value;
    if(password === email){
      return { passwordSameAsUsernameOrEmail: true };
    }
    return null;
  }

  addNewExaminee(): void {
    const apiData = {
      // collectioId: this.collectionId,
      firstName: this.examineeDetailsForm.value.firstName.trim(),
      lastName: this.examineeDetailsForm.value.lastName.trim(),
      phone: this.examineeDetailsForm.value.phone,
      emailId: this.examineeDetailsForm.value.emailId.trim(),
      active: this.examineeDetailsForm.value.status,
      password: this.examineeDetailsForm.value.password,
    }


    this.examineeData$ = this.examineesService.createNewExaminee(apiData).subscribe((resData: any) => {
      this.examineesService.getExaminees()?.subscribe(resData => {
        this.examineesService.newExamineeList(resData);
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
      this.notificationService.success(resData.message);
      this.router.navigate(["/examinees"]);
      this.dialogRef.close();
      if (resData.examineeId) {
        // this.messageService.sendMessage('Examinee added successfully');
        // this.router.navigate(["/examinees"]);
      }
    },
      error => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        if (error?.status == 409) {
          this.examineeDetailsForm.patchValue({ "emailId": null });
        }
        // this.examineeDetailsForm.reset()
        this.examineeDetailsForm.controls['emailId'].reset()
        // if (error.error.error == 'Conflict') {
        //   this.duplicateDataFlag = true;
        //   this.notificationService.warn('Duplicate email id');
        // }
      });
  }

  onTestNameControlFocus(): void {

    this.duplicateDataFlag = false;

  }

  navigateToLandingPage(): void {
    this.router.navigate(["/examinees"]);
  }
}
